/** A higher number results in performance issues with the AceEditor */
export const editorMaxLines = 50;
